export type PublicationImageOrigin = "starter" | "upload"

export interface PublicationAttachedImage {
  file: File
  origin: PublicationImageOrigin
}

export function canPublishWithStarterRule(params: {
  text: string
  image: PublicationAttachedImage | null
  videoFile: File | null
}): boolean {
  const hasText = params.text.trim().length > 0
  const hasOwnImage = params.image?.origin === "upload"
  const hasVideo = params.videoFile !== null
  return hasText || hasOwnImage || hasVideo
}

export function publicationImagesToFiles(images: PublicationAttachedImage[]): File[] {
  return images.map((i) => i.file)
}
